/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.0334 5c0 2.2091-1.7946 4-4.0084 4-2.2137 0-4.0083-1.7909-4.0083-4 0-2.2091 1.7946-4 4.0083-4 2.2138 0 4.0084 1.7909 4.0084 4Zm-1.5031 0c0 1.3807-1.1217 2.5-2.5053 2.5-1.3835 0-2.5052-1.1193-2.5052-2.5s1.1217-2.5 2.5052-2.5c1.3836 0 2.5053 1.1193 2.5053 2.5ZM19.989 21.5c.0348.4918.0527.992.0527 1.499V23H4.0084v-.0013c0-.5069.0179-1.007.0527-1.4987C4.5198 15.0268 7.9104 10 12.025 10c4.1147 0 7.5053 5.0268 7.964 11.5Zm-14.4207 0c.209-2.7383.9802-5.1419 2.0682-6.9062C8.9342 12.4895 10.528 11.5 12.025 11.5c1.4971 0 3.0909.9895 4.3886 3.0938 1.088 1.7643 1.8592 4.1679 2.0682 6.9062H5.5683ZM22.2463 7c0 1.6569-1.3459 3-3.0062 3s-3.0063-1.3431-3.0063-3 1.346-3 3.0063-3c1.6603 0 3.0062 1.3431 3.0062 3Zm-1.5031 0c0 .8284-.673 1.5-1.5031 1.5-.8302 0-1.5031-.6716-1.5031-1.5s.6729-1.5 1.5031-1.5c.8301 0 1.5031.6716 1.5031 1.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.2401 11.25c-.4151 0-.7516.3358-.7516.75s.3365.75.7516.75c1.4809 0 2.9257 1.3986 3.2074 3.5h-1.9826c-.4151 0-.7516.3358-.7516.75s.3365.75.7516.75H24V17c0-3.0108-1.9833-5.75-4.7599-5.75Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.76 10c-1.6604 0-3.0063-1.3431-3.0063-3s1.3459-3 3.0062-3 3.0063 1.3431 3.0063 3-1.346 3-3.0063 3Zm0-1.5c-.8302 0-1.5032-.6716-1.5032-1.5s.673-1.5 1.5031-1.5c.8302 0 1.5031.6716 1.5031 1.5S5.59 8.5 4.76 8.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.5115 12c0-.4142-.3365-.75-.7516-.75C1.9832 11.25 0 13.9892 0 17v.75h3.5351c.4151 0 .7516-.3358.7516-.75s-.3365-.75-.7516-.75H1.5525c.2817-2.1014 1.7265-3.5 3.2074-3.5.415 0 .7516-.3358.7516-.75Z"
    />
  </React.Fragment>,
  'Developers'
);
